import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as MoneyBag } from '@pkg/assets/icons/v2/crypto-money-bag.svg';
import { DepButton, DepButtonDisplay } from '@pkg/components/deprecated';

interface CryptoStepTooMuchProps {
    onContinue: () => void;
}

export const CryptoStepTooMuch = ({ onContinue }: CryptoStepTooMuchProps) => {
    const { t } = useTranslation(['yat_picker']);

    return (
        <div className="yat-picker-checkout__sidebar-vertical">
            <div>
                <div className="yat-picker-checkout__sidebar-moneybag">
                    <MoneyBag />
                </div>
                <h2 className="yat-picker-checkout__sidebar-cryptotitle">{t('pay_crypto_too_much_title')}</h2>
                <p className="yat-picker-checkout__sidebar-cryptoinstruct">{t('pay_crypto_too_much_instruction')}</p>
                <div>
                    <DepButton display={DepButtonDisplay.block} onClick={onContinue}>
                        Continue
                    </DepButton>
                </div>
            </div>
        </div>
    );
};
